<div
  #scrollable
  class="overflow-auto position-relative"
  [scrollTop]="scrollTopSubject | async"
  [ngStyle]="{ height: viewportHeightSubject | async }"
>
  <div class="position-top-left full-stretch">
    <div  *ngFor="let pdfDocument of pdfDocumentsSubject | async ">
      <ss-pdf-title
        [title]="pdfDocument.shortDisplay"
      >
      </ss-pdf-title>

      <ss-pdf-document-viewport [pdfDocument]="pdfDocument"></ss-pdf-document-viewport>
    </div>
  </div>

  <ng-container *ngIf="addedPageContentSubject | async">
    <ng-container
      *ngTemplateOutlet="
        addedPageContentSubject | async;
        context: { 
          service: pdfDocumentViewportsContainerService
        }
      "
    ></ng-container>
  </ng-container>

</div>
